import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_preview-suite/artifacts/bkqjgsqq_RteQ_Solutions_Logo-removebg-preview.png";

const Footer = () => {
  const location = useLocation();
  const { t } = useLanguage();

  const footerLinks = [
    { name: t('nav.home'), href: '/' },
    { name: t('nav.suite'), href: '/suite' },
    { name: t('nav.services'), href: '/services' },
    { name: t('nav.company'), href: '/company' },
    { name: t('nav.contact'), href: '/contact' },
  ];

  const isActive = (href) => {
    return location.pathname === href;
  };

  return (
    <footer className="bg-[#05050A] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <Link
              to="/"
              className="flex-shrink-0"
              data-testid="footer-logo"
            >
              <img 
                src={LOGO_URL} 
                alt="RTEQ Solutions" 
                className="h-10 w-auto"
              />
            </Link>
          </motion.div>

          <nav className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
            {footerLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm transition-colors ${
                  isActive(link.href) ? 'text-white' : 'text-zinc-500 hover:text-white'
                }`}
                data-testid={`footer-link-${link.href.replace('/', '') || 'home'}`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          <p className="text-sm text-zinc-600">
            &copy; {new Date().getFullYear()} RTEQ Solutions
          </p>
        </div>

        <div className="mt-8 pt-8 border-t border-white/5 text-center">
          <p className="text-xs text-zinc-600">
            {t('footer.tagline')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
